import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { Box, TextField } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import { useForm, Controller } from 'react-hook-form'

import { BaseDialog, LoadingFeedback } from 'components'

import * as service from 'service'

import useFetch from 'hooks/useFetch'
import useSnackbar from 'hooks/useSnackbar'

const RegisterResponsiblesDialog = ({ open, onClose, category, onRefresh }) => {
  const [loading, setLoading] = useState(false)

  const { control, handleSubmit, reset } = useForm({
    defaultValues: {
      responsibles: category.responsibles || [],
    },
  })

  const { response: usersResponse, isLoading: loadingUsers } = useFetch(
    service.dponet.users.get,
    { perPage: 1000, minimal: true },
    [open],
    open,
  )

  const snackbar = useSnackbar()
  const users = usersResponse?.data?.users || []

  const handleSave = async (data) => {
    setLoading(true)
    try {
      await service.dponet.complaintCategories.registerResponsibles({
        categoryId: category.id,
        responsiblesIds: data.responsibles.map((user) => user.id),
      })
      snackbar.open({
        message: 'Responsáveis registrados com sucesso!',
        variant: 'success',
      })
      onRefresh()
      onClose()
    } catch (error) {
      console.error('Erro ao registrar responsáveis:', error)
      snackbar.open({
        message: 'Erro ao registrar responsáveis',
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  const handleClose = () => {
    onClose()
    reset()
  }

  return (
    <BaseDialog
      dialogSize="sm"
      fullWidth
      open={open}
      setOpen={handleClose}
      title="Registrar Responsáveis"
      actionButton={handleSubmit(handleSave)}
      actionButtonText="Salvar"
      closeButtonText="Cancelar"
      disableButton={loading || loadingUsers}
      loading={loading || loadingUsers}
    >
      <LoadingFeedback open={loading || loadingUsers} />
      <Box pt={1} pb={2}>
        <Controller
          name="responsibles"
          control={control}
          defaultValue={[]}
          onChange={([, data]) => data}
          as={
            <Autocomplete
              multiple
              fullWidth
              loading={loadingUsers}
              options={users}
              getOptionLabel={(option) => option.name || ''}
              getOptionSelected={(option, value) => option.id === value.id}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Responsáveis"
                  variant="outlined"
                  placeholder="Selecione os responsáveis"
                />
              )}
            />
          }
        />
      </Box>
    </BaseDialog>
  )
}

RegisterResponsiblesDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  category: PropTypes.object.isRequired,
  onRefresh: PropTypes.func.isRequired,
}

export default RegisterResponsiblesDialog
